import { render, staticRenderFns } from "./BWSelect.vue?vue&type=template&id=28150590&scoped=true"
import script from "./BWSelect.vue?vue&type=script&lang=js"
export * from "./BWSelect.vue?vue&type=script&lang=js"
import style0 from "./BWSelect.vue?vue&type=style&index=0&id=28150590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28150590",
  null
  
)

export default component.exports